var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import FolderSvg from './folder.icon.svg';
export const FolderIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: FolderSvg }));
_react_refresh_temp_1 = FolderIcon;
$RefreshReg$(_react_refresh_temp_1, "FolderIcon");
